import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'industryStatus'
})
export class IndustryStatusPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    let milisecondsDiff:any;

    if(value){
      let startDate:any = new Date(value);
      let endDate:any = new Date();

      milisecondsDiff = ((endDate - startDate)/(1000*60*60));

      if(milisecondsDiff >= 24){
        return 'Offline';
      }else if(milisecondsDiff >= 1 && milisecondsDiff < 24){
          return 'Delay';
      }else{
        return 'Online';
      }
    }else{
      return 'Offline';
    }

  }

}
